export default function RecordNotFound({ text = "Record not found" }) {
  return (
    <div
      style={{
        width: "100%",
        textAlign: "center",
        padding: "24px 12px",
        color: "#6b7280",
        fontWeight: 600,
      }}
    >
      {text}
    </div>
  );
}

